module.exports = ".gauge-ring ::ng-deep text {\n  text-anchor: start !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/chart/gauge-ring-chart/gauge-ring-chart.component.less
// module id = ./src/app/shared/components/chart/gauge-ring-chart/gauge-ring-chart.component.less
// module chunks = main